import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/passphrase');

export default function PEPHint() {
  return <Content />;
}
